import { Text } from "@repo/skapa";
import { type PropsWithChildren, type ReactNode } from "react";

interface DescriptionListProps extends PropsWithChildren {
  className?: string;
}

interface DescriptionListItemProps {
  title: ReactNode;
  description: ReactNode;
  className?: string;
}

export const DescriptionList = ({
  children,
  className,
}: DescriptionListProps) => {
  return <dl className={className}>{children}</dl>;
};

export const DescriptionListItem = ({
  title,
  description,
  className,
}: DescriptionListItemProps) => {
  return (
    <div className={className}>
      <Text tagName="dt" textStyle="Heading.XS">
        {title}
      </Text>
      <Text tagName="dd">{description}</Text>
    </div>
  );
};
